// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_nv-5";
export var filledCircle = "_nv-4";
export var historyEntry = "_nv-3";
export var messageSideLeft = "_nv-1";
export var messageSideRight = "_nv-2";
export var orderTrackingCarouselWrapper = "_nv-6";
export var orderTrackingInfoContainer = "_nv-0";